const normalizeRole = (role) => {
    if (!role) {
        return null;
    }
    if (typeof role === "string") {
        return role;
    }
    return role.authority || null;
};

const hasAnyRole = (user, expectedRoles) => {
    return !!(user && Array.isArray(user.roles) && user.roles.some(role => expectedRoles.includes(normalizeRole(role))));
};

// Hilfsfunktion zur Überprüfung der Admin-Rolle
export const isUserAdmin = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN"]);
};

export const canManageHeating = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_HEATING"]);
};

export const canManageKiosk = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_KIOSK"]);
};

export const canManageDrinks = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_GETRAENKE"]);
};

export const canManageWorkDuty = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_ARBEITSDIENSTLEITUNG"]);
};

export const canManageClubEvents = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_VORSTAND"]);
};

export const canExportTournamentParticipants = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_VORSTAND"]);
};

export const canExportKnockoutBracket = (user) => {
    return hasAnyRole(user, ["ROLE_ADMIN", "ROLE_GROUP_ADMIN", "ROLE_GROUP_VORSTAND"]);
};
